import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          "rounded-lg border border-line bg-bg-0 px-3 py-2 text-sm text-ink-1 placeholder:text-ink-3",
          "focus:border-accent focus:outline-none",
          className,
        )}
        {...props}
      />
    );
  },
);
